module.exports = __webpack_public_path__ + "img/logo-footer.c415a863.svg";